<template functional>
  <a-sub-menu :key="props.menuInfo.key" style="background-color:#72C7C2; color:white;lineheight:32px">
    <span slot="title" > 
      <!--<ecp-icon type='iconwenjianjia' style="color:#000;"/>-->
        <a-icon type="folder" style="font-size:17px;color:#000;" class="middle"/>
        <span style="">{{ props.menuInfo.title }}</span>
    </span>
    <template v-for="item in props.menuInfo.children">
      <a-menu-item
        ref="menu"
        style="line-height:40px;height:40px;padding-left:20px;background-color:#5cbcb6;margin:0;color:white;"
        v-if="!item.children"
        :key="item.key"
        :data="item.data">
        <!--<ecp-icon type='iconmorentubiao'/>-->
          <a-icon type="file" style="font-size:14px;color:#000;" class="middle"/>
         <a-tooltip placement="right" overlayClassName='menu-pop'>
           <template slot="title">
              {{ item.title }}
            </template>
           <span class="font12 middle menu-content">{{ item.title }}</span>
         </a-tooltip>
      </a-menu-item>
      <a-sub-menu
        v-else
        style="background-color:rgb(92, 188, 182);"
        :key="item.key">
        <span slot="title"> 
          <!--<ecp-icon type='iconwenjianjia'  />-->
            <a-icon type="folder" style="font-size:17px;color:#000;" class="middle"/>
            <span class="menu-content">{{item.title}}</span>
        </span>
        <template v-for="one in item.children">
          <a-menu-item
            ref="smenu"
            style="line-height:40px;height:40px;padding-left:20px;background-color:#46b2ab;margin:0;color:white;"
            :key="one.key"
            :data="one.data">
            <!-- <a-icon type="pie-chart" style="font-size:17px" class="middle"/> -->
            <a-tooltip placement="right" overlayClassName='menu-pop'>
              <template slot="title">
                  {{ one.title }}
                </template>
                <!--<ecp-icon type='iconmorentubiao'/>-->
                <a-icon type="file" style="font-size:14px;color:#000;" class="middle"/>
                <span class="font12 middle menu-content">{{ one.title }}</span>
            </a-tooltip>
          </a-menu-item>
        </template>
      </a-sub-menu>
    </template>
  </a-sub-menu>
</template>
<script>
import {Icon} from 'ant-design-vue'
const EcpIcon = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_1492035_u3vrd27nj5i.js'
  })
  export default {
    props: ['menuInfo'],
    components:{
      EcpIcon
    }
  }
</script>